module.exports = __webpack_public_path__ + "img/BANNER-2.68b30e45.png";